import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreCollection,
  AngularFirestoreDocument
} from 'angularfire2/firestore';
import * as firebase from 'firebase';
import { Observable } from 'rxjs/Observable';
import { Investor } from '../modules/shared/models/investor';
import { AuthService } from './auth.service';
import { User } from './user';

@Injectable()
export class InvestorDataService {
  user: User;
  private investorCollection: AngularFirestoreCollection<Investor>;
  list: AngularFirestoreCollection<Investor>;
  constructor(private afs: AngularFirestore, private authService: AuthService) {
    this.investorCollection = this.afs.collection<Investor>('InvestorData');
    authService.getCurrentUser().subscribe(user =>{
      this.user = user;
    })
  }

  addInvestorData(data: Investor) {
    console.log("SAVING","add Investor", data)
    data.searchName = data.name.toLocaleLowerCase();
    const cleanData = JSON.parse(JSON.stringify(data));
    cleanData.createdAt = firebase.firestore.FieldValue.serverTimestamp();
    cleanData.updatedAt = firebase.firestore.FieldValue.serverTimestamp();
    cleanData.RAName = this.user.displayName;
    console.log(cleanData);
    if(!this.user.displayName){
      console.log("display name not found");
      return ;
    }
    console.log(this.user.displayName);
    this.investorCollection
      .add(cleanData)
      .then(value => {
        console.log(value);
        console.log(value.id);
        data.iid = value.id;
        this.afs.doc<Object>('InvestorData/' + value.id).set(
          {
            iid: value.id
          },
          {
            merge: true
          }
        );
      })
      .catch(error => {
        console.log(error);
      });
  }
  editInvestorData(data: Investor) {
    console.log("SAVING","edit Investor", data)
    data.searchName = data.name.toLocaleLowerCase();
    const cleanData = JSON.parse(JSON.stringify(data));
    cleanData.updatedAt = firebase.firestore.FieldValue.serverTimestamp();
    console.log('from service', cleanData);
    if(cleanData.RAName.length == 0){
      cleanData.RAName = this.user.displayName;
    }
    this.afs
      .doc<Object>('InvestorData/' + cleanData.iid)
      .set(cleanData, {
        merge: true
      })
      .then(value => {
        console.log(value);
      })
      .catch(error => {
        console.log(error);
      });
  }

  deleteInvestorData(id: string) {
    this.afs.doc<Object>('InvestorData/' + id).delete();
  }

  getKey() {
    return this.investorCollection;
  }
  getInvestorByKey(iid: string) {
    return this.afs.doc<Investor>(`InvestorData/${iid}`).ref;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/investor-data.service.ts